module.exports = __webpack_public_path__ + "static/media/en-cancel-package_3.fec28bb1.png";